import { css } from '@emotion/css';
import { useAccountSelector } from 'src/hooks';
import { MTypography } from 'src/lib';
import { Spacing } from 'src/styles';
import { getAccountFundingInstructions } from 'src/utils';

/** Beats MTypography's margin reset. No top margin, so a bold title stays attached to the text under it. */
const paragraph = css`
  && {
    ${Spacing.mb16}
  }
`;

/** A later block in the same section, separated from the block above it. */
const continuedParagraph = css`
  && {
    ${Spacing.my16}
  }
`;

/** Space above a section title. mt16 beats MTypography's margin reset. */
const sectionHeading = css`
  && {
    ${Spacing.mt16}
  }
`;

export const DepositByWireInstructions = () => {
  const { account } = useAccountSelector();

  return (
    <>
      <MTypography variant='body1' className={paragraph}>
        Incoming wires are free and must be initiated with your financial institution. Wire transfers typically require
        1 business day to process. Please instruct your bank to include the sender name on the wire. This information
        must be included for the transfer to be credited to your account. A rejected wire may incur a bank fee.
      </MTypography>

      <MTypography variant='body1' weight='bold'>
        Third-party Wires:
      </MTypography>
      <MTypography variant='body1' className={paragraph}>
        <MTypography variant='body1' weight='bold' inline>
          My IPO does not accept “third party” funding of any kind
        </MTypography>
        . This means that the name on your bank account must match the name on your My IPO account exactly. For example,
        money transfers from a trust or business bank account (owned by you) to an individual or joint My IPO account
        are considered third-party and{' '}
        <MTypography variant='body1' weight='bold' inline>
          will not be accepted.
        </MTypography>
      </MTypography>

      <MTypography variant='body1' weight='bold'>
        Please send USD incoming wires as follows:
      </MTypography>
      <MTypography variant='body1' className={paragraph}>
        <span>BMO Harris Bank</span> <br />
        <span>111 W. Monroe St.</span> <br />
        <span>Chicago, IL 60603</span> <br />
      </MTypography>

      <MTypography variant='body1' className={continuedParagraph}>
        <span>ABA: 071000288 (for non-domestic USD wires, use SWIFT Code: HATRUS44)</span>
        <br />
        <span>Acct: 3713286</span>
        <br />
        <span>FBO: Apex Clearing Corporation</span>
        <br />
        <span>FCC: {getAccountFundingInstructions(account)}</span>
        <br />
      </MTypography>

      <MTypography variant='body1' weight='bold' className={sectionHeading}>
        IMPORTANT NOTE:
      </MTypography>
      <MTypography variant='body1' className={paragraph}>
        Without FFC Information, your wire may be rejected. If your bank does not have a specific FFC instruction field,
        enter the Account Holder’s Name and Account Number in the &quot;Message to recipient&quot; or &quot;Message to
        recipient bank&quot; field.
      </MTypography>

      <MTypography variant='body1' weight='bold'>
        Please include the address for Apex Clearing on incoming wires:
      </MTypography>
      <MTypography variant='body1' className={paragraph}>
        <span>Apex Clearing Corporation</span>
        <br />
        <span>350 N St Paul, Ste. 1300</span>
        <br />
        <span>Dallas, TX 75201</span>
        <br />
      </MTypography>
    </>
  );
};
